<template>
  <div class="baniere pb-20">
    <popupProject
      :want-to-make-offer="activeProjet"
      @oga="retourProjet"
    />
    <div
      class="w-full"
      data-aos="fade-right"
      data-aos-duration="2000"
    >
      <div class="titre md:w-4/5 w-full pr-4">
        Amélioration de l’efficacité des ventes et de la satisfaction des clients
      </div>
    </div>

    <div
      class="title1 mt-5 pr-0"
      data-aos="fade-up"
      data-aos-duration="2000"
    >
      Le moteur de flux de travail intégré garantit un délai rapide de décision et de décaissement. La solution fournit une image concise au réseau de vente, aux gestionnaires de risques et au back-office dans le but d'accélérer et d'automatiser les prêts. DIGILOAN offre une grande souplesse dans le traitement des clients, des produits de prêt, des flux de travail et des règles commerciales. Des capacités de visualisation uniques offrent un confort d'utilisation, même pour les structures complexes de prêts et de garanties et les problèmes de notation.
    </div>

    <div class="text-center mt-10">
      <img
        src="../../../assets/images/jpg/schema.jpg"
        alt=""
        class=""
        data-aos="fade-up"
        data-aos-duration="2000"
      >
    </div>
    <div class="flex justify-center w-full md:mt-20 mt-6">
      <div
        class="button mt-6 md:w-1/5 w-4/5 mb-4"
        data-aos="fade-up"
        data-aos-duration="2000"
        @click="openProjet"
      >
        Demander une démo
      </div>
    </div>
  </div>
</template>

<script>
import popupProject from '@/components/popup/popupProject'

export default {
  name: 'Index',
  components: {
    popupProject
  },
  props: {
  },
  data () {
    return {
      activeProjet: false
    }
  },
  created () {
  },
  methods: {
    openProjet () {
      this.activeProjet = true
    },

    retourProjet (answer) {
      this.activeProjet = answer
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/style/sass/variables";
.baniere{
  height: auto ;
  background-color: $white;
  position: relative;
  padding-left: $padding-l;
  padding-right: $padding-r;
}

.titre{
  font-weight: 800;
  font-size: 40px;
  line-height: 150%;
  letter-spacing: 0.01em;
  color: $black;
}
.title1{
  font-weight: normal;
  font-size: 24px;
  line-height: 160%;
  color: $black;
}
.button{
  background-color: $dev-green;
  height: 60px;
  border-radius: 0px;
  border: none;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 29px;
  color: white;
}
@media screen and (max-width: 600px){
  .baniere{
    padding-left: 20px;
    padding-right: 20px;
  }
  .titre{
    font-size: 28px;
  }
  .title1{
    font-size: 18px;
  }
}

@media screen and (min-width: 701px) and (max-width: 1024px){
  .baniere{
    padding-left: $padding-l-1024;
    padding-right: $padding-r-1024;
  }
  .titre{
    font-size: 30px;
  }
  .titre1{
    font-size: 20px;
  }

  .blocc {
    padding: 30px;
  }
  .button{
    width: 30%;
  }
}
</style>
